import {
  Flex,
  Typography,
} from 'antd'
import React from 'react'

import { useFormatTime } from '@/hooks/use-format-time'
import { SalesSettings } from '@/redux/sales-settings'

import AttributionDisplay from './attribution-display'
import s from './sales-settings-display.module.css'

const { Text, Title } = Typography

export interface SalesSettingsDisplayProps {
  salesSettings: SalesSettings
  showEffectedAt?: boolean
}

export default function SalesSettingsDisplay({
  salesSettings: {
    effectAt,
    saleSetHours,
    saleSetMinutes,
    tipsMessagesStatus,
    tipsPostsStatus,
    tipsProfileStatus,
    tipsStoriesStatus,
    tipsStreamsStatus,
    postsStatus,
  },
  showEffectedAt,
}: SalesSettingsDisplayProps) {
  const formatTime = useFormatTime()

  return (
    <div>
      <Flex justify="space-between" align="center" style={{ marginBottom: 10 }}>
        <div>
          <Title level={5} style={{ margin: 0 }}>Customize how employee earnings are calculated in your reports</Title>
        </div>
        {showEffectedAt && (
          <Text type="danger">
            Changes take effect on {formatTime()(effectAt)}
          </Text>
        )}
      </Flex>
      <table className={s.Table}>
        <tbody>
          <tr>
            <td>
              <Title level={5}>Message</Title>
            </td>
            <td>
              <AttributionDisplay type="message" />
            </td>
          </tr>
          {(tipsMessagesStatus ||
            tipsPostsStatus ||
            tipsProfileStatus ||
            tipsStoriesStatus ||
            tipsStreamsStatus) && (
              <tr>
                <td>
                  <p><Title level={5}>Tips</Title></p>
                </td>
                <td>
                  <AttributionDisplay
                    type="tips"
                    saleSetHours={saleSetHours}
                    saleSetMinutes={saleSetMinutes}
                  />
                </td>
              </tr>
            )}
          {postsStatus && (
            <tr>
              <td><Title level={5}>Posts</Title></td>
              <td>
                <AttributionDisplay type="post" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
